import * as React from 'react';

class CBRENotification extends React.Component<any, any> {
    constructor(props: any) {
        super(props)
    }
    render() {
        return (
            <div className="notification">Notification</div>
        );
    }

}

export default CBRENotification;